<template>
  <validation-observer ref="AddForm" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted()">
      <b-row>
        <b-col md="12">
          <b-form-group label="Title" label-for="task_title">
            <validation-provider
              #default="{ errors }"
              name="Title"
              vid="Title"
              rules="required"
            >
              <b-form-input
                id="task_title"
                placeholder="Title"
                required
                v-model="task.title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="Milestone" label-for="milestones">
            <b-form-select
              id="milestones"
              @change="selectedMilestone"
              v-model="task.milestonesId"
              :disabled="currentMilestonesId != null"
              :options="milestonesList"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Start Date" label-for="start_date">
            <validation-provider
              #default="{ errors }"
              name="State Date"
              vid="Start Date"
              rules="required"
            >
              <b-form-datepicker
                id="start_date"
                class="mb-1"
                v-model="task.startDate"
                  :date-format-options="{ day: '2-digit', month: 'short', year: 'numeric' }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="End Date" label-for="end_date">
            <validation-provider
              #default="{ errors }"
              name="End Date"
              vid="End Date"
              rules="required"
            >
              <b-form-datepicker
                id="end_date"
                :min="task.startDate"
                placeholder="Choose a date"
                l
                v-model="task.endDate"
                  :date-format-options="{ day: '2-digit', month: 'short', year: 'numeric' }"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Assignee" label-for="assignee">
            <validation-provider
              #default="{ errors }"
              name="Assignee"
              vid="Assignee"
              rules="required"
            >
              <b-form-select
                v-model="task.assignee"
                :options="assignee_options"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Status" label-for="status">
            <b-form-select
              id="status"
              v-model="task.status"
              :options="statusOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Priority" label-for="priority">
            <b-form-select
              id="priority"
              v-model="task.priority"
              :options="priorityOptions"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Comment" label-for="task_description">
            <b-form-textarea
              id="task_description"
              placeholder="Comment"
              rows="3"
              v-model="task.description"
            />
          </b-form-group>
        </b-col>

        <!-- submit and reset -->
        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="button" @click="formSubmitted" variant="primary"
            >Submit</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  customError,
  customLoader,
  customSwal,
  fnSortingDropdown,
} from "@/libs/customFn";
import "@/libs/customValidation";
import { readonly } from "@vue/composition-api";
export default {
  name: "AddProject",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    milestonesId: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      purchaseDate: null,
      currentMilestonesId: this.milestonesId,
      lifeEndDate: null,
      maintainanceDate: null,
      location: "",
      selected: null,
      currentDate: new Date().toISOString().split("T")[0],
      costPerHour: 0,
      priorityOptions: [
        { value: "NOTSPECIFIED", text: "Not Specified" },
        { value: "LOW", text: "Low" },
        { value: "MEDIUM", text: "Medium" },
        { value: "HIGH", text: "High" },
      ],
      statusOptions: [
        { value: "NOTSTARTED", text: "Not Started" },
        { value: "INPROGRESS", text: "In Progress" },
        { value: "ONHOLD", text: "On Hold" },
        { value: "COMPLETED", text: "Completed" },
      ],

      assignee_options: [],
      milestonesList: [],
    };
  },

  methods: {
    ...mapActions("projectModule", [
      "getProjectAssigneesAction",
      "addProjectTaskAction",
      "getProjectMilestoneAction",
    ]),
    async formSubmitted() {

      let isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        let loader = customLoader("Please wait while the task is being added");
        // console.log("date", this.currentDate);
        // console.log("date2", this.task.startDate);
        // console.log("date3", this.task.endDate);
        let payload = {
          projectId: this.$route.params.id,
          ...this.task,
          assignee: this.task.assignee.id,
          assigneeName: this.task.assignee.name,
          startDate: this.task.startDate,
          
  //         startDate: this.currentDate || !isNaN(new Date(this.task.startDate).getTime())
  // ? new Date(this.task.startDate).toISOString()
  // : null,
          endDate: this.task.endDate,
        };
        this.addProjectTaskAction(payload)
          .then(() => {
            loader.close();
            this.success();
          })
          .catch((error) => {
            loader.close();
            this.error(error.response.data);
          });
      }
    },

    selectedMilestone() {
      console.log("list",this.milestones);
    const milestoneselect = this.milestones.find(
      (milestone) => milestone.id === this.task.milestonesId
    );
    console.log("milestoneselect",milestoneselect);
    
    if (milestoneselect) {
      this.task.startDate = milestoneselect.startDate;
      this.task.endDate = milestoneselect.endDate;
    }
  },

    success() {
      this.$swal({
        title: "Task Added!",
        text: "You have successfully added the Task!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$emit("taskAdded");
          this.resetForm(); 
        }
      });
    },
    error(data) {
      this.$swal("Error!", this.getErrorString(data) || "Failed!", "error");
    },
    getErrorString(data) {
      let msg =
        "";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop]
            .toString()
            .replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },
    resetForm() {
  this.$refs.AddForm.reset(); // Reset form validation
  this.task = {}; // Reset form data
},
  },

  computed: {
    ...mapGetters("projectModule", {
      assignees: "assignees",
      loading: "loading",
      milestones: "milestones",
    }),
  },
  async mounted() {
    await this.getProjectAssigneesAction().then(() => {
      console.log(this.assignees);
      this.assignee_options = this.assignees.map((assignee) => ({
        value: {
          id: assignee.id,
          name: `${assignee.firstName} ${assignee.lastName}`,
        },
        text: `${assignee.firstName} ${assignee.lastName}`,
      }));
    });

    await this.getProjectMilestoneAction(this.task.projectId).then((res) => {
      this.milestonesList = fnSortingDropdown(
        this.milestones,
        "asc",
        "name"
      ).map((v, i) => {
        return { value: v.id, text: v.name };
      });
    });
  },
};
</script>
